var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face {\r\n    font-family: \"el-iconfont\";\r\n    /* Project id 4442622 */\r\n    src: url(" + escape(require("./iconfont.woff2?t=1708676987973")) + ") format('woff2'), url(" + escape(require("./iconfont.woff?t=1708676987973")) + ") format('woff'), url(" + escape(require("./iconfont.ttf?t=1708676987973")) + ") format('truetype');\n}\n.el-iconfont {\r\n    font-family: \"el-iconfont\" !important;\r\n    font-size: 16px;\r\n    font-style: normal;\r\n    -webkit-font-smoothing: antialiased;\r\n    -moz-osx-font-smoothing: grayscale;\n}\n.el-icon-sort:before {\r\n    content: \"\\E666\";\n}", ""]);

// exports
